import { ERequestStatus } from '../../types/requestStatus';
import { IPostForm, TPostFormFields } from '../../types/postForm';
import { EPostFormActionType, TPostFormActions } from './postFormActions';

export const createInitialState = <F extends TPostFormFields = {}>(fields: F): IPostForm<F> => ({
  fields,
  formMessage: '',
  formStatus: ERequestStatus.Initial,
});

export const createPostFormReducer = <F extends TPostFormFields = {}, A extends TPostFormActions = TPostFormActions>(
  initialState: IPostForm<F>,
) => {
  return (state = initialState, action: A) => {
    switch (action.type) {
      case EPostFormActionType.Loading:
        return { ...state, formStatus: ERequestStatus.Loading };

      case EPostFormActionType.Succeed:
        return { ...state, ...action.payload, formStatus: ERequestStatus.Succeed };

      case EPostFormActionType.Failed:
        return { ...state, formStatus: ERequestStatus.Failed };

      case EPostFormActionType.SetField:
        return {
          ...state,
          fields: {
            ...state.fields,
            [action.payload.fieldName]: action.payload.value,
          },
        };

      case EPostFormActionType.Reset:
        return initialState;

      default:
        return state;
    }
  };
};
